import { OverlayBadgeDesignTokens } from '../../../../types/overlaybadge';

export default {
    root: {
        outline: {
            width: '2px',
            color: '{content.background}'
        }
    }
} as OverlayBadgeDesignTokens;
